import { useAllDeals } from "hooks/use-all-deal-data";
import { DealFilter } from "types/filters";

export const getDealsForFilters = (
    filters: DealFilter[],
    signatureEventId?: string
): Queries.DealFieldsFragment[] => {
    
    // if there are no filters and no signature event, return all deals
    if (filters.length === 0 && !signatureEventId) {
        return useAllDeals();
    }

    // if there are no filters, return all deals for signature event
    if (filters.length === 0) {
        return useAllDeals().filter((deal) =>
            deal.signatureEvent?.id === signatureEventId
        );
    }

    const dealsForFilterUniversalTags = getDealsForUniversalTags(filters, signatureEventId);

    return dealsForFilterUniversalTags;
};

const getDealsForUniversalTags = (
    filters: DealFilter[],
    signatureEventId?: string
): Queries.DealFieldsFragment[] => {
    const deals = useAllDeals();

    // get filters where __typename = DatoCmsUniversalTag
    const universalTagFilters = filters.filter(
        (filter) => filter.__typename === "DatoCmsUniversalTag"
    );

    if (universalTagFilters.length === 0) {
        return [];
    }


    return deals.filter((deal) => {

        // check for signatureEventId
        if (signatureEventId && deal.signatureEvent?.id !== signatureEventId) {

            return false; // No matches found, exclude this deal
            
        }

        return deal.universalTags?.some((tag) => {
            return universalTagFilters.some((filter) => filter.id === tag?.id);
        });
    });
}

